import axios from "axios";

export default {
  namespaced: true,
  strict: true,
  state: {
    Authenticated: false,
    userID: "",
  },
  getters: {
    getAuthenticated(state) {
      return state.Authenticated;
    },
    getUserID(state) {
      return state.userID;
    },
    getUserIDQueryParamName() {
      return process.env.VUE_APP_userIDLoginQueryParam;
    },
    getAuthDigestQueryParamName() {
      return process.env.VUE_APP_authDigestLoginQueryParam;
    },
  },
  mutations: {
    setAuthenticated(state, payload) {
      state.Authenticated = payload.authenticated;
    },
    setUserID(state, payload) {
      state.userID = payload;
    },
  },
  actions: {
    async setAuthCookieAsync(state, authDigest) {
      //call GET on /login
      let params = { params: {} };
      if (authDigest) {
        params["authDigest"] = authDigest;
      }
      try {
        await axios.get("login", params).then((res) => {
          if (res.status == 200) {
            state.commit("setAuthenticated", res.data);
          } else {
            //invalid current authentication and force login?
            state.commit("setAuthenticated", { authenticated: false });
            state.commit("setUserID", "");
          }
        });
      } catch (err) {
        //display "We're Sorry" page
        state.commit("setAuthenticated", { authenticated: false });
        state.commit("setUserID", "");
      }
    },
    async loginUserAsync(state, payload) {
      //call POST on /login
      await axios
        .post("login", payload)
        .then((res) => {
          if (res.status == 200) {
            state.commit("setAuthenticated", res.data);
            state.commit("setUserID", payload.userID);
          }
        })
        .catch(() => {
          //failed to log already handled
        });
    },
    async logoutUserAsync(state) {
      try {
        await axios.delete("login").then((res) => {
          if (res.status == 200) {
            state.commit("setAuthenticated", res.data);
          }
        });
      } catch (err) {
        //something has gone catastrophically wrong
      } finally {
        state.commit("setAuthenticated", { authenticated: false });
        state.commit("setUserID", "");
      }
    },
  },
};
